export const DEFAULT_CPF_LIMITS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export const INITIAL_EVENT_FORM_VALUES = {
  type: '',
  name: '',
  description: '',
  image: null,
  pointsPerTicket: '',
  eventLimitPerCpf: '',
  address: '',
  city: '',
  state: '',
  isRemoteEvent: false,
  days: [
    {
      date: '',
      startTime: '',
      endTime: '',
      ticketQuantity: '',
      limitPerCpf: ''
    }
  ],
  regulations: '',
  faq: [
    {
      question: '',
      answer: ''
    }
  ],
  brands: {
    BOT: true,
    QDB: true,
    BLZ: true,
    EUD: true
  },
  redeemStart: {
    date: '',
    time: ''
  },
  redeemEnd: {
    date: '',
    time: ''
  },
  benefitId: null
}
